import { connect } from "react-redux";
import { DesignChapterContentBlock as Component } from "../../../Notebook/DesignChapterContentBlock";
import {
  getDesignChapterOptions,
  getViewTypeForStepOptions,
} from "./DesignChapterContentBlock.selector";
import { viewThreeSetStep, viewFourSetStep } from "@learningblocks/exp-redux";

function mapStateToProps(state) {
  return {
    options: getDesignChapterOptions(state),
    viewType: getViewTypeForStepOptions(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetStepViewThree: (params) => dispatch(viewThreeSetStep(params)),
    onSetStepViewFour: (params) => dispatch(viewFourSetStep(params)),
  };
}

export const DesignChapterContentBlock = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
